import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useContext } from 'react';

import { getRebookerActive } from 'src/api/rebookersService';

import { queryRetry } from '../query-retry';
import { AuthContext } from '../../providers/auth-context';

export const useGetBuildingRebookerActive = (roomCode: string, enabled: boolean) => {
    const userState = useContext(AuthContext);

    return useQuery<boolean, AxiosError>({
        enabled: userState.loggedIn && enabled && !!roomCode,
        queryKey: ['isRebookerActive', roomCode],
        queryFn: () => getRebookerActive(roomCode),
        retry: queryRetry,
    });
};
